import { useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import api from "../../services/api";
import logo from "../../assets/logo.png";
import { useParams } from "react-router-dom";
import "./styles.css";
import { useRef } from "react";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import DescricaoHu from "./DescricaoHu";

const SvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
  >
    <path
      d="M10 0L16 6V18C16 18.5304 15.7893 19.0391 15.4142 19.4142C15.0391 19.7893 14.5304 20 14 20H2C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H10ZM14 18V7H9V2H2V18H14ZM8 17L4 13H6.5V10H9.5V13H12L8 17Z"
      fill="#3900DB"
    />
  </svg>
);

const style = {
  table: {
    borderCollapse: "collapse",
    width: "50%",
    textAlign: "left",
    marginTop: "20px",
    marginBottom: "20px",
  },
  th: {
    width: "50%",
    color: "#00293B",
    borderBottom: "1px solid #ddd",
    padding: "10px",
    fontSize: "18px",
    fontWeight: "bold",
    backgroundColor: "#57575826",
  },
  td: {
    borderBottom: "1px solid #ddd",
    padding: "10px",
    fontSize: "16px",
  },
  tdEven: {
    //cor de fundo para linhas pares
    borderBottom: "1px solid #ddd",
    padding: "10px",
    fontSize: "16px",
    backgroundColor: "rgba(228,228,231,0.2)",
  },
};

function Pdf({ atividade, documentTitle }) {
  // Função para extrair todas as HUs de todos os épicos
  const getAllHistoriasUsuario = () => {
    return (
      atividade.epicos?.flatMap(
        (epico) =>
          epico.historias_usuario?.map((hu) => ({
            ...hu,
            titulo_epico: epico.titulo_epico,
          })) || []
      ) || []
    );
  };

  return (
    <div className="page">
      <div className="print-logo-title">
        <img className="img-logo-fn" alt="logo" src={logo} />
        <p className="titulo-ata">{documentTitle}</p>
      </div>

      <p className="titulo_wrapper">1. Informações básicas:</p>

      <div id="dados-info-basicas" className="subtitle">
        <div
          className="info-basicas"
          style={{ marginTop: "2%", display: "flex", flexDirection: "row" }}
        >
          <div className="data-field">
            <span style={{ color: "#00293B", fontWeight: "bold" }}>Data: </span>
            <span style={{ color: "#00293B" }} className="smallsize">
              {atividade.mes} / {atividade.ano}
            </span>
          </div>
        </div>
      </div>

      <div className="pagebreak">
        <p className="titulo_wrapper">2. Épicos:</p>
        <table style={style.table}>
          <thead>
            <tr>
              <th style={style.th}>Título do Épico</th>
              <th style={style.th}>Descrição do Épico</th>
            </tr>
          </thead>
          <tbody>
            {atividade.epicos
              ?.filter((epico) => epico.id_epico)
              .map((epico, index) => (
                <tr key={epico._id}>
                  <td style={index % 2 === 0 ? style.tdEven : style.td}>
                    {epico.titulo_epico}
                  </td>
                  <td style={index % 2 === 0 ? style.tdEven : style.td}>
                    {epico.descricao_epico}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <div className="pagebreak">
        <p className="titulo_wrapper">3. Histórias de Usuário:</p>
        <div className="hu-list">
          {getAllHistoriasUsuario().map((hu, index) => (
            <div key={hu._id} className="hu-item">
              <h2 className="hu-title">{hu.titulo_hu}</h2>
              <ul className="hu-details">
                <li>
                  <strong>Épico:</strong>{" "}
                  {hu.titulo_epico || "Sem épico associado"}
                </li>
                <li>
                  <strong>Descrição:</strong>{" "}
                  <DescricaoHu
                    html={hu.descricao_hu_html}
                    text={hu.descricao_hu}
                  />
                </li>
                <li>
                  <strong className="block">Funcionalidade:</strong>
                  <div
                    className="inline-block border-l-4 border-black pl-3 bg-gray-100 font-mono"
                    dangerouslySetInnerHTML={{
                      __html: hu.funcionalidade || "Sem funcionalidade",
                    }}
                  />
                </li>
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const AtividadePdf = () => {
  const { mes, ano } = useParams();
  const [atividade, setAtividade] = useState(null);
  const history = useHistory();
  const documentTitle = `Relatório de Atividades ${mes}-${ano}`;
  const token = localStorage.getItem("auth-token");
  const pdfRef = useRef();

  const handleCancel = () => {
    history.push("/perfil");
  };

  const handlePrint = useReactToPrint({
    content: () => pdfRef.current,
    documentTitle,
    onAfterPrint: () => {
      toast.info(
        <>
          <SvgIcon />
          {" Download realizado!"}
        </>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    },
  });

  useEffect(() => {
    handlePrint();
  }, [handlePrint]);

  useEffect(() => {
    const buscarAtividade = async () => {
      try {
        const response = await api.get("/relatorioatividade", {
          params: { mes, ano },
          headers: {
            "X-Auth-Token": token,
            "content-type": "application/json",
          },
        });
        setAtividade(response.data);
      } catch (error) {
        console.error("Erro ao buscar atividade:", error);
      }
    };
    buscarAtividade();
  }, [mes, ano, token]);

  return atividade ? (
    <div style={{ marginTop: "45px" }}>
      <br />
      <center>
        <Button
          label="Cancelar"
          className="p-button-outlined p-button-primary cancelar-pdf"
          style={{
            color: "red",
            fontWeight: "600",
            backgroundColor: "#fff",
            marginTop: "12px",
            marginBottom: "20px",
            marginRight: "5px",
          }}
          onClick={handleCancel}
        />
        <Button
          label="Exportar como pdf"
          className="p-button-outlined p-button-primary download-pdf"
          style={{
            color: "white",
            fontWeight: "600",
            backgroundColor: "#00293B",
            marginTop: "12px",
            marginBottom: "20px",
          }}
          onClick={handlePrint}
        />
        <div ref={pdfRef}>
          <Pdf atividade={atividade[0]} documentTitle={documentTitle} />
        </div>
      </center>
      <br />
      <br />
    </div>
  ) : (
    <p>Carregando...</p>
  );
};

export default AtividadePdf;
